import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'tc-client-common';
import * as consts from '../../../const';
class QlikReportVisualisationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.reportContainer = React.createRef();
  }

  openFullScreen = () => {
    if (this.reportContainer.current.requestFullscreen) {
      this.reportContainer.current.requestFullscreen();
    } else if (this.reportContainer.current.mozRequestFullScreen) {
      /* Firefox */
      this.reportContainer.current.mozRequestFullScreen();
    } else if (this.reportContainer.current.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.reportContainer.current.webkitRequestFullscreen();
    } else if (this.reportContainer.current.msRequestFullscreen) {
      /* IE/Edge */
      this.reportContainer.current.msRequestFullscreen();
    }
  };

  render() {
    const reportUrl = this.props.url;
    const iframeContent = '<iframe id="report-iframe" src="' + reportUrl + '"></iframe>';
    return (
      <div className="report-graphs">
        <h4>{consts.REPORT_VISUALISATION}</h4>
        <Button
          theme="default"
          label={consts.FULL_SCREEN}
          handleClick={() => this.openFullScreen()}
          id="full-screen-btn"
        />
        <div dangerouslySetInnerHTML={{ __html: iframeContent }} id="report-container" ref={this.reportContainer} />
      </div>
    );
  }
}

QlikReportVisualisationComponent.propTypes = {
  url: PropTypes.string.isRequired
};
export default QlikReportVisualisationComponent;
